import React from "react";
import { GiWindow } from "react-icons/gi";
import { FaLuggageCart } from "react-icons/fa";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { GiOfficeChair, Gi3DStairs } from "react-icons/gi";
import { MdOutlineConstruction } from "react-icons/md";

import "./Services.css";

function Services() {
  return (
    <div className="services-container" id="services">
      <h4 className="title">VÅRA TJÄNSTER</h4>
      <div className="d-inline-flex flex-wrap ">
        <div className="flex-items">
          <h5 className="services-subTitle">Fönsterputs</h5>
          <div className="icon">
            <GiWindow size={50} />
          </div>
          <p className="service-text">
            Ibland kan det vara svårt att hinna med allt, därför kan det vara
            skönt att lämna över fönsterputsning till oss
          </p>
        </div>
        <div className="flex-items">
          <h5 className="services-subTitle">Flyttstädning</h5>
          <div className="icon">
            <FaLuggageCart size={50} />
          </div>
          <p className="service-text">
            Att göra en flyttstädning själv kan vara både jobbigt och svårt, men
            du är inte ensam om att tycka det.
          </p>
        </div>
        <div className="flex-items">
          <h5 className="services-subTitle">Hemstädning</h5>
          <div className="icon">
            <MdOutlineMapsHomeWork size={50} />
          </div>
          <p className="service-text">
            Rengöring av badkar, dusch och toalett, torkning av badrumsskåp
            utvändigt, rengöring av kran och handfat, torkning av väggar.
          </p>
        </div>
        <div className="flex-items">
          <h5 className="services-subTitle">Kontorstädning</h5>
          <div className="icon">
            <GiOfficeChair size={50} />
          </div>
          <p className="service-text">
            En regelbunden städning av företagets arbetsplatser är viktig för
            både din egen och dina medarbetares hälsa och trivsel.
          </p>
        </div>
        <div className="flex-items">
          <h5 className="services-subTitle">Trappstädning</h5>
          <div className="icon">
            <Gi3DStairs size={50} />
          </div>
          <p className="service-text">
            Vi städar trappor åt stora och små bostadsföreningar idag. Vi jobbar
            med ett väl utprövat arbetssätt vilket borgar för hög kvalitet och
            god miljö.
          </p>
        </div>
        <div className="flex-items">
          <h5 className="services-subTitle">Byggstädning</h5>
          <div className="icon">
            <MdOutlineConstruction size={50} />
          </div>
          <p className="service-text">
            Av oss får ni en prisvärd och kostnadseffektiv städning av ett
            företag som tar fullt ansvar för städningen.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Services;
